import { PlanContentPresetsCopyContextProvider } from "../../context/plan-content-presets-copy.context";
import { useLoaderData } from "react-router-dom";
import PlanContentPresetsCopy from "./PlanContentPresetsCopy";

function PlanContentPresetsCopyContainer(props) {
	const loaderData = useLoaderData();

	return (
		<PlanContentPresetsCopyContextProvider
			plan={loaderData?.plan}
			organization={loaderData?.organization}
		>
			<PlanContentPresetsCopy {...props} />
		</PlanContentPresetsCopyContextProvider>
	);
}

export default PlanContentPresetsCopyContainer;
